 
import SendIcon from '@mui/icons-material/Send';
import styled from 'styled-components';
import { mobile } from "../responsive";

const Container = styled.div`
  height: 60vh;
  background-color: #f7e4e4;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`
const Title = styled.h1`font-size:70px;
 margin: 20px;
 ${mobile({
  fontSize:"50px",

  })}
`
const Desc = styled.div`
  font-size: 24px;
  font-weight: 300;
  margin-bottom: 20px;
  ${mobile({
   textAlign:"center",

  })}
`
const InputContainer = styled.div`
 width: 50%;
 height: 10%;
 display: flex;
 justify-content: space-between;
 border: 1px solid lightgray;
 ${mobile({
    width: "70%",

  })}
`
const Input = styled.input`
border:none;
flex: 8;
padding-left: 20px;
`
const Button = styled.button`
flex: 1;
border: none;
background-color: teal;
cursor: pointer;
&:hover{
background-color: #008080b9;

}
`

const Newsletter = () => {
  return (
    <Container>
        <Title>Newsletter</Title>
        <Desc>Get Timely Updates from Your favorite Products.</Desc>
        <InputContainer>
        <Input placeholder='Your e-mail' />
        <Button>
            <SendIcon/>
        </Button>
        </InputContainer>

    </Container>
  )
}

export default Newsletter
